<app-banner></app-banner>

<section class="main-section white-bg">
    <div class="width-container">
        <h2 id="error-header" tabindex="-1" class="no-outline" [innerHtml]="'ERROR.PROMOTION_ERROR.HEAD' | translate"></h2>
        <p [innerHtml]="'ERROR.PROMOTION_ERROR.DESC' | translate"></p>
        <button class="btn" [innerHtml]="'ERROR.PROMOTION_ERROR.CTA_BTN' | translate" (click)="onBack()"></button>
        <button class="btn btn-alt" [innerHtml]="'ERROR.PROMOTION_ERROR.CTA_BTN2' | translate" [attr.aria-label]="'ERROR.PROMOTION_ERROR.CTA2_ARIA' | translate" (click)="otherOffers()"></button>
        <a target="_blank" id="other-offers" aria-hidden="true" tabindex="-1" class="visuallyhidden" [href]="'ERROR.PROMOTION_ERROR.CTA2_LINK' | translate"></a>
    </div>
</section>